import { render, staticRenderFns } from "./atlas_wx.vue?vue&type=template&id=562adda2&scoped=true&"
import script from "./atlas_wx.vue?vue&type=script&lang=js&"
export * from "./atlas_wx.vue?vue&type=script&lang=js&"
import style0 from "./atlas_wx.vue?vue&type=style&index=0&id=562adda2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562adda2",
  null
  
)

export default component.exports